/**
 * Mock data for pools and images.
 * Temporary until the formal PoolManagement service is available.
 */

import type { Pool, ImageCatalogEntry } from '@/types';

export const MOCK_POOLS: Pool[] = [
  {
    poolId: 'default',
    displayName: 'Default',
    region: 'us',
    imageIds: ['azlinuxwithscript', 'azlinuxnginxv3'],
  },
];

export const MOCK_IMAGES: ImageCatalogEntry[] = [
  {
    imageId: 'azlinuxwithscript',
    name: 'Azure Linux with Script',
    description: 'Azure Linux image with provisioning script',
    os: 'linux',
    latestRevision: 1,
    tags: ['azlinux', 'latest'],
    createdAt: '2026-02-01T10:00:00Z',
  },
  {
    imageId: 'azlinuxnginxv3',
    name: 'Azure Linux with Nginx',
    description: 'Azure Linux image pre-configured with Nginx reverse proxy and static site hosting',
    os: 'linux',
    latestRevision: 3,
    tags: ['azlinux', 'nginx', 'web'],
    createdAt: '2026-02-15T14:00:00Z',
  },
];
